import React from 'react';

import { type ModalV2Id } from 'src/types/modalV2';

import { useModalsV2Context } from './useModalsV2Context';

export const useModalV2 = () => {
  const { openModal, closeModal, state } = useModalsV2Context();

  const [isClosureAllowed, setIsClosureAllowed] = React.useState(true);

  const closeModalWithCheck = React.useCallback(
    (id: ModalV2Id) => {
      if (isClosureAllowed) {
        closeModal(id);
      }
    },
    [closeModal, isClosureAllowed],
  );

  return {
    state,
    openModal,
    closeModal: closeModalWithCheck,
    switchClosability: setIsClosureAllowed,
  };
};
